/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const ClaimsSchemaFieldFileValue: core.serialization.ObjectSchema<
    serializers.ClaimsSchemaFieldFileValue.Raw,
    Truvity.ClaimsSchemaFieldFileValue
> = core.serialization.object({
    isArray: core.serialization.property('is_array', core.serialization.boolean().optional()),
    name: core.serialization.string(),
    notEmpty: core.serialization.property('not_empty', core.serialization.boolean().optional()),
    title: core.serialization.string().optional(),
});

export declare namespace ClaimsSchemaFieldFileValue {
    export interface Raw {
        is_array?: boolean | null;
        name: string;
        not_empty?: boolean | null;
        title?: string | null;
    }
}
